(function(){
  var busy=false,io=null,url=null;
  var css='.lh-inf{display:flex;align-items:center;justify-content:center;gap:10px;padding:28px 0 8px;font:500 13.5px "Instrument Sans",system-ui,sans-serif;color:rgba(35,29,20,.6)}.lh-inf__dot{width:16px;height:16px;border-radius:50%;border:2px solid rgba(92,107,63,.25);border-top-color:#5c6b3f;opacity:0}.lh-inf.is-on .lh-inf__dot{opacity:1;animation:lhspin .8s linear infinite}.lh-inf.is-end .lh-inf__dot{display:none}@keyframes lhspin{to{transform:rotate(360deg)}}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);
  function pagOf(root){return root.querySelector('.pagination-wrapper')||root.querySelector('nav.pagination')}
  function nextUrl(p){var a=p&&p.querySelector('.pagination__list li:last-child a.pagination__item-arrow');return a?a.href:null}
  function load(s,grid){
    busy=true;s.classList.add('is-on');
    fetch(url).then(function(r){return r.text()}).then(function(h){
      var d=new DOMParser().parseFromString(h,'text/html');
      var items=d.querySelectorAll('#product-grid > li');
      items.forEach(function(li){grid.appendChild(document.importNode(li,true))});
      var c=d.getElementById('ProductGridContainer');url=c?nextUrl(pagOf(c)):null;
      busy=false;s.classList.remove('is-on');
      if(!url||!items.length){io&&io.disconnect();s.classList.add('is-end');s.querySelector('.lh-inf__t').textContent='You\u2019ve seen them all.'}
    }).catch(function(){busy=false;s.classList.remove('is-on')});
  }
  function setup(){
    if(io){io.disconnect();io=null}
    var c=document.getElementById('ProductGridContainer'),grid=document.getElementById('product-grid');
    if(!c||!grid)return;
    var p=pagOf(c);if(!p)return;
    url=nextUrl(p);p.style.display='none';
    if(!url||c.querySelector('.lh-inf'))return;
    var s=document.createElement('div');s.className='lh-inf';s.innerHTML='<span class="lh-inf__dot"></span><span class="lh-inf__t">Loading more\u2026</span>';
    p.parentNode.insertBefore(s,p);
    io=new IntersectionObserver(function(e){if(e[0].isIntersecting&&!busy&&url)load(s,grid)},{rootMargin:'900px 0px'});
    io.observe(s);
  }
  function init(){setup();var c=document.getElementById('ProductGridContainer');if(c)new MutationObserver(function(){if(!c.querySelector('.lh-inf'))setup()}).observe(c,{childList:true})}
  if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
})();
